<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e8qFT9/images/cover.jpg?1685327251383" alt="This image is the cover for the book Long Road Back, 2011 Advent -"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long Road Back, 2011 Advent -
      </h1>
      <p class="bookDescription body article font2">
        <p>Yoo Lee Shin had great hopes for his new life studying engineering in Australia, but nothing could have prepared him for the wonder of falling in love. His roommate’s brother, Craig, is beautiful, kind, and brave—and, very shortly after they meet, he’s deployed. As Christmas nears, can Shin keep hope for a happy ending bright enough to guide Craig to him on the long road back?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L.J. LaBarthe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2166f4a2